module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "backgroundcolor"
  }), _c('div', {
    staticClass: "recipes overflow-x-hidden"
  }, [_c('div', {
    staticClass: "menucontent"
  }, [_c('div', {
    staticClass: "sectiontitre"
  }, [_c('span', {
    staticClass: "titretestintro"
  }, [_vm._v("THE "), _c('br')]), _c('span', {
    staticClass: "titretest"
  }, [_vm._v("RECIPES")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })]), _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carouselimages"
  }, _vm._l((_vm.container), function(recette) {
    return _c('div', {
      staticClass: "recettecard relative pointer"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'info-recipe-show',
          params: {
            id: recette.id,
            titre: recette.titre,
            image: recette.medias[0].image.url,
            description: recette.description
          }
        }
      }
    }, [_c('div', {
      staticClass: "recettetop"
    }, [_c('img', {
      staticClass: "imagerecette inset-shadow",
      attrs: {
        "src": recette.medias[0].image.url
      }
    })]), _c('div', {
      staticClass: "recettebottom"
    }, [_c('p', {
      staticClass: "recettetitre"
    }, [_vm._v(_vm._s(recette.titre))]), _c('i', {
      staticClass: "iconeplus fa fa-plus"
    })])])], 1)
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8c9008","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Story/Recipes.vue
// module id = 1282
// module chunks = 1